import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPendingActivitiesReport extends Layout {
    checkboxPageBreak: Checkbox;
    excludabletextboxCustomers: ExcludableTextbox;
    excludabletextboxMarketingActivities: ExcludableTextbox;
    excludabletextboxOperationsUser: ExcludableTextbox;
    excludabletextboxSalesManager: ExcludableTextbox;
    excludabletextboxSalesperson: ExcludableTextbox;
    sourcePendingActivitiesReport: DataSource;
    switchIncludePastDue: Switch;
    textboxCustomerProspectType: Textbox;
    textboxDueDate: Textbox;
    textboxDueDateSingle: Textbox;
    textboxGroupBy: Textbox;
    textboxSortBy: Textbox;
}
